$(document).on('click', '.type-select-control', function () {
	$(this).toggleClass('open');
	closeAllCheckbox();
});

$(document).on('click', '.type-checkbox-control', function () {
	var target = $(this).data('target'),
		checkboxList = $('.type-checkbox-list'),
		wrappper = $('.type-checkbox-list-wrapper');

	$('.type-select-control').removeClass('open');

	if ($(this).hasClass('open')) {
		$('.type-checkbox-control').removeClass('open');
		checkboxList.hide();
		$(target).hide();
		wrappper.hide();
	} else {
		wrappper.show();
		$('.type-checkbox-control').removeClass('open');
		$(this).addClass('open');
		checkboxList.show();
		$(target).show();
	}
});

$(document).on('click', '.type-checkbox-list-close', function () {
	$('.type-checkbox-control').removeClass('open');
	$('.type-checkbox-list-wrapper').fadeOut(200);
	$('.type-checkbox-list').fadeOut(200);
});

function closeAllCheckbox() {
	$('.type-checkbox-list-wrapper').fadeOut(200);
	$('.type-checkbox-list').fadeOut(200);
	$('.type-checkbox-control').removeClass('open');
}

showCruiseLink();

function showCruiseLink() {
	if ((document.getElementById('boatType-9') !== null && document.getElementById('boatType-9').checked === true ) || (document.getElementById('boatFilter-3') !== null && document.getElementById('boatFilter-3').checked === true ))
		document.getElementById('bt9').style.display = 'block';
	else
		document.getElementById('bt9').style.display = 'none';
}

$(document).on('click', '#mobile-control-button-filter', function () {
	$('.type-checkbox-list').fadeIn(200);
	$('.type-checkbox-list-wrapper').fadeIn(200);
});
//
//function reset_filter() {
//	$('input[type="checkbox"]').prop('checked', false);
//	$('.type-checkbox-control').removeClass('open');
//	$('#mobile-control-button-filter').removeClass('open');
//	run_filter_timeout(0);
//}
//
$.nette.ext({
	success: function (payload) {
		window.history.pushState('', window.document.title, payload.url);
		closeAllCheckbox();
		$('.type-select-control').removeClass('open');
		showCruiseLink();
		loadMapMarkers();
	},
	start: function () {
		toggleSpinner()
	},
	complete: function (xhr, status) {
		toggleSpinner()
	}
});

var timeout;
$(document).on('change', '.filter-checkbox', function () {
	clearTimeout(timeout);
	timeout = setTimeout(function () {
		filter();
	},1000)
});


function filter() {
	var boatType = [],
		boatFilter = [],
		difficulty = [],
		rentalType = [],
		sectionType = $('.activities-content-results-row').data('section-type'),
		itemType = $('.activities-content-results-row').data('item-type');
	$("input:checkbox[name='boatType[]']:checked").each(function () {
		boatType.push($(this).val());
	});
	$("input:checkbox[name='difficulty[]']:checked").each(function () {
		difficulty.push($(this).val());
	});
	$("input:checkbox[name='rentalType[]']:checked").each(function () {
		rentalType.push($(this).val());
	});
	$("input:checkbox[name='boatFilter[]']:checked").each(function () {
		boatFilter.push($(this).val());
	});

	$.nette.ajax({
		type: 'GET',
		url: filterDataUrl,
		data: {
			sectionType: sectionType,
			itemType: itemType,
			boatType: boatType,
			boatFilter: boatFilter,
			difficulty: difficulty,
			rentalType: rentalType,
		}
		,
		success: function (payload) {
			window.history.pushState('', window.document.title, payload.url)
		}
	});
}

//
window.addEventListener('popstate', function (e) {
	window.location = window.location.href;
});

/** SPINNER */
function toggleSpinner() {
	$('.activities-spinner-wrapper').toggleClass('shown');
}


$(window)
	.scroll(function () {
		list_page_map_scroll();
	})
	.resize(function () {
		list_page_map_scroll();
	});

var el = $('.activities-header'),
	lpm = $('.activities-map'),
	lpc = $('.activities-col-left'),
	lpcr = $('.activities-content-results');

function list_page_map_scroll() {
	var
		st = $(window).scrollTop(),
		header_height = $(window).width() >= 580 ? 110 : 84;
	var
		map_pos_top = header_height,
		height = $(window).height() - header_height;

	lpc.css('min-height', height);

	var pos_bottom = st + $(window).height() - lpc.offset().top - lpc.outerHeight();

	if (pos_bottom < 0)
		pos_bottom = 0;

	if ($(window).width() > 1024) {
		if (st <= (lpc.offset().top - header_height) || pos_bottom !== 0) {
			if (st > lpc.offset().top - header_height) {
				lpm.css('top', lpc.outerHeight() - height);
			} else {
				lpm.css('top', el);
			}

			lpm
				.css({
					'position': 'relative',
					'left': 0,
					'right': 0,
					'width': '100%',
					'height': height + 'px'
				});
		} else {
			lpm
				.css({
					'position': 'fixed',
					'top': 'auto',
					'left': '65%',
					'right': 0,
					'bottom': 0,
					'width': '35%',
					'-webkit-transform': 'translateY(0)',
					'-moz-transform': 'translateY(0)',
					'-ms-transform': 'translateY(0)',
					'-o-transform': 'translateY(0)',
					'transform': 'translateY(0)'
				});
		}
		lpm
			.css('height', height + 'px')
			.css('z-index', 1);
	} else {
		lpm.removeAttr('style');
	}
}

list_page_map_scroll();


/** MAP */
var google_api_key = 'AIzaSyBeiJYnPrLfuOrxgn6gc_UemoMdUyj5O68', // Frontend api key
	map,
	infoWindow;


$(document).on('click', '.activities-content-map-icon,.activities-map-header .close, #mobile-control-button-map', function () {
	$('.activities-map').toggleClass('show');

	var html = $('html');
	if (html.hasClass('no-scroll'))
		html.removeClass('no-scroll');
	else if ($(window).width() <= 440 || $(window).height() <= 500)
		html.addClass('no-scroll');
});

var gapi_script = document.createElement('script');
gapi_script.src = 'https://maps.googleapis.com/maps/api/js?key=' + google_api_key + '&callback=initMap';
document.head.appendChild(gapi_script);

var map_markers = [];
var markerCluster;
var map_cards = function () {
	return $('.activities-content-results-row').data('json-results');
};

function initMap() {
	map = new google.maps.Map(document.getElementById('google-map'), {
		center: {lat: 49.0484601, lng: 14.4418441},
		zoom: 14
	});
	infoWindow = new google.maps.InfoWindow({
		maxWidth: 240
	});
	loadMapMarkers();
}

function loadMapMarkers() {
	setMapOnAll(null);
	map_markers = [];

	for (var ic in map_cards()) {
		addMarker(map_cards()[ic]);
	}
	var bounds = new google.maps.LatLngBounds();
	for (var i = 0; i < map_markers.length; i++) {
		bounds.extend(map_markers[i].getPosition());
	}

	//markerCluster = new MarkerClusterer(map, map_markers, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});

	map.fitBounds(bounds);
}

function setMapOnAll(map) {
	for (var i = 0; i < map_markers.length; i++) {
		map_markers[i].setMap(map);
	}
	if (markerCluster)
		markerCluster.clearMarkers();
}

function addMarker(item) {
	var contentString = '<a href="' + item.url + '" class="activities-map-card">' +
		'<img src="' + item.photo + '" class="activities-map-card-photo">' +
		'<p class="activities-map-card-title">' + item.title + '</p>';

	if (item.address)
		contentString += '<p class="activities-map-card-address">' + item.address + '</p>';

	contentString += '</a>';

	var marker = new google.maps.Marker({
		position: {lat: item.gps_lat, lng: item.gps_lng},
		map: map,
		id: item.id,
		info: contentString,
		title: item.title,
		url: item.url,
		icon: '/assets/svg/icon_map_pin.svg'
	});

	google.maps.event.addListener(marker, 'click', function () {
		infoWindow.setContent(this.info);
		infoWindow.open(map, this);
	});

	map_markers.push(marker);
}

function showOnMap(id) {
		if (window.innerWidth <= 1024)
		{
			$('.activities-map').toggleClass('show');

			var html = $('html');
			if (html.hasClass('no-scroll'))
				html.removeClass('no-scroll');
			else if ($(window).width() <= 440 || $(window).height() <= 500)
				html.addClass('no-scroll');
		}

		for (var ic in map_markers)
		{
			if (map_markers.hasOwnProperty(ic))
			{
				if (map_markers[ic].id === id) {
					infoWindow.setContent(map_markers[ic].info);
					infoWindow.open(map, map_markers[ic]);
					if ($(window).width() < 1024)
						$('.activities-content-map-icon').trigger('click');
					map.setZoom(14);
					map.setCenter(map_markers[ic].getPosition())
				}
			}
		}

}